import React, { Component } from 'react';
//import Config from './Config';
import Menu from './Menu';
import Order from './Order';
import Admin from './Admin';
import Customer from './Customer';
import Delivery from './Delivery';
import Dispatch from './Dispatch';
import Product from './Product';
import Account from './Account';
import PackingStation from './PackingStation';
import StockTake from './StockTake';
import Reports from './Reports';
import CustReturn from './CustReturn';
import Settings from './Settings';
import LogOut from './LogOut';
import Invoicing from './Invoicing';
//import Confirm from './Confirm';
import Dashboard from './Dashboard';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/Panel.css';
//import FX from './functions/functions';

class Panel extends Component {
  search = () => {
    var search_str;
    if(document.getElementById("search_text")){
      search_str = document.getElementById("search_text").value;
    }
    console.log(search_str);
  }
  showMenu = () => {
    this.props.root.setState({menu_show: !this.props.root.state.menu_show});
  }
  textAction = (e) => {
    if(typeof this.props.root.textAction === 'function'){
      this.props.root.textAction(e);
    }
  }
  render() {
  var out,title;
    switch(this.props.panel){
      case 'dashboard':
        title = 'Dashboard';
        out = <Dashboard  root={this.props.root} />;
        break;
      case 'orders':
        out = <Order root={this.props.root} />;
        title = 'Order';
        break;
      case 'admin':
        out = <Admin root={this.props.root} />;
        title = 'Admin';
        break;
      case 'deliveries':
        out = <Delivery root={this.props.root} />;
        title = 'Delivery';
        break;
      case 'returns':
        out = <CustReturn root={this.props.root} />;
        title = 'Customer Returns';
        break;
      case 'customers':
        out = <Customer root={this.props.root} />;
        title = 'Customer';
        break;
      case 'dispatches':
        out = <Dispatch root={this.props.root} />;
        title = 'Dispatch';
        break;
      case 'products':
        out = <Product root={this.props.root} />;
        title = 'Product';
        break;
      case 'settings':
        out = <Settings root={this.props.root} />;
        title = 'Settings';
        break;
      case 'packing_station':
        out = <PackingStation root={this.props.root} />;
        title = 'Packing Station';
        break;
      case 'dispatch_lookup':
        out = <Dispatch root={this.props.root} all_customers={true}/>;
        title = 'Dispatch Lookup';
        break;
      case 'order_lookup':
        out = <Order root={this.props.root} all_customers={true}/>;
        title = 'Order Lookup';
        break;
      case 'stock_take':
        out = <StockTake root={this.props.root} />;
        title = 'Stock Take';
        break;
      case 'account':
        out = <Account root={this.props.root} />;
        title = 'Account';
        break;
      case 'reports':
        out = <Reports root={this.props.root} />;
        title = 'Reports';
        break;
      case 'logout':
        out = <LogOut root={this.props.root} />;
        title = 'Logout';
        break;
      case 'invoicing':
        out = <Invoicing root={this.props.root} />;
        title = 'Invoicing';
        break;
      default:
        title = 'Not Found';
        out = 'zzz';
        break;
    }
    document.title = title + ' :: My VDepot';
    var className = 'Panel';
    if(this.props.root.state.waiting){
        className += ' waiting';
    }
    var customerName;
    if(this.props.root.state.customers && this.props.root.state.customers.length && this.props.root.state.customer_id){

      this.props.root.state.customers.some(cust => {
        //console.log( this.props.root.state.customer_id);
        //console.log( cust.id );

        if(parseInt(cust.id,10) === parseInt(this.props.root.state.customer_id,10)){
          customerName = cust.name;
          return true;
        }
        return false;
      })
    }

    var ident;
    if(this.props.root.state.user){
        var forename = '';
        if( this.props.root.state.user.forename){
          forename = this.props.root.state.user.forename.length > 12 ? this.props.root.state.user.forename.substr(0,1): this.props.root.state.user.forename;
        }
        var surname = '';
        if(this.props.root.state.user.surname){
          surname = forename.length + this.props.root.state.user.surname.length >30 ? this.props.root.state.user.surname.substr(0,1): this.props.root.state.user.surname;
        }
        if(!(forename + surname).length){
          surname = this.props.root.state.user.username;
        }

        ident = (
          <div className="ident">
              <div className="userName">{forename} {surname}</div>
              <div className="customerName">{customerName}</div>
          </div>
        )
    }
    var search;
    if(false){

        search  =  (<div id="SearchBar">
              <input id="search_text" placeholder="Search" onChange={this.textAction} />
              <button id="search_btn" onClick={this.search}><i className="material-icons">search</i></button>
            </div>)
    }
    return (
      <div className={className} id="Panel">
          <div className="TopBar">
            <div className="MenuShow" onClick={this.showMenu}><img src="/images/menu.png" alt="" title="" /></div>
            <div className="Title">{title}</div>
            {search}
            {ident}
        </div>
        <Menu root={this.props.root} />
        <div className="Visor">
          {out}
        </div>
      </div>
    );
  }
}

export default Panel;

/*<p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.<br/>
          {System.go}
          {Config.api}
          <button onClick={this.bop}>Zing</button>
          <button onClick={FX.load}>Funk</button>
          <button onClick={FX.navigate.bind(this,'/commisar')}>Zag</button>


          {window.location.href}<br/>
          {window.location.hostname}<br/>
          {window.location.port}<br/>
          {window.location.pathname}<br/>
          {window.location.search}
        </p>*/



// WEBPACK FOOTER //
// ./src/Panel.js